class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector("details");
    this.content =
      this.mainDetailsToggle.querySelector("summary").nextElementSibling;

    this.mainDetailsToggle.addEventListener(
      "focusout",
      this.onFocusOut.bind(this),
    );
    this.mainDetailsToggle.addEventListener("toggle", this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute("open")) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute("open");
    this.mainDetailsToggle
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
  }
}

customElements.define("details-disclosure", DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  static #minHeightCalculated = false;
  static #headerLeaveSetup = false;

  constructor() {
    super();
    this.header = document.querySelector(".header-wrapper");

    this.addEventListener("mouseenter", this.onMouseEnter.bind(this));

    // Prevent closing the menu when clicking the summary of an already-open menu on desktop
    const summary = this.mainDetailsToggle.querySelector("summary");
    if (summary) {
      summary.addEventListener("click", (event) => {
        if (window.innerWidth < 990) return;
        if (this.mainDetailsToggle.hasAttribute("open")) {
          event.preventDefault();
        }
      });
    }
  }

  connectedCallback() {
    if (window.innerWidth < 990) return;

    // Set up a single mouseleave listener on the header wrapper + mega menu content
    if (!HeaderMenu.#headerLeaveSetup && this.header) {
      HeaderMenu.#headerLeaveSetup = true;

      this.header.addEventListener("mouseleave", (event) => {
        if (window.innerWidth < 990) return;
        // Check if mouse moved into a mega-menu dropdown (which is positioned outside header-wrapper)
        const related = event.relatedTarget;
        if (
          related &&
          related.closest &&
          related.closest(".mega-menu__content")
        )
          return;
        HeaderMenu.closeAllMenus();
      });

      // When mouse leaves the mega-menu dropdown content
      document.addEventListener(
        "mouseleave",
        (event) => {
          if (window.innerWidth < 990) return;
          const target = event.target;
          if (
            !target.classList ||
            !target.classList.contains("mega-menu__content")
          )
            return;
          // Check if mouse went back into header or another mega-menu content
          const related = event.relatedTarget;
          if (related && related.closest) {
            if (
              related.closest(".header-wrapper") ||
              related.closest(".mega-menu__content")
            )
              return;
          }
          HeaderMenu.closeAllMenus();
        },
        true,
      );
    }

    if (HeaderMenu.#minHeightCalculated) return;
    // Defer to ensure all header-menu elements are in the DOM
    requestAnimationFrame(() => {
      if (HeaderMenu.#minHeightCalculated) return;
      HeaderMenu.#minHeightCalculated = true;

      let maxHeight = 0;
      const allMenus = document.querySelectorAll("header-menu");
      allMenus.forEach((menu) => {
        const details = menu.querySelector("details");
        const content = details.querySelector(".mega-menu__content");
        if (!content) return;
        details.setAttribute("open", "");
        const height = content.getBoundingClientRect().height;
        if (height > maxHeight) maxHeight = height;
        details.removeAttribute("open");
      });

      if (maxHeight > 0) {
        document.documentElement.style.setProperty(
          "--mega-menu-height",
          `${maxHeight}px`,
        );
        allMenus.forEach((menu) => {
          const content = menu.querySelector(".mega-menu__content");
          if (content) content.style.minHeight = `${maxHeight}px`;
        });
      }
    });
  }

  static closeAllMenus() {
    document
      .querySelectorAll("header-menu details[open]")
      .forEach((details) => {
        details.removeAttribute("open");
        details.querySelector("summary").setAttribute("aria-expanded", "false");
      });
  }

  onMouseEnter() {
    if (window.innerWidth < 990) return;
    // Close other open header menus
    document
      .querySelectorAll("header-menu details[open]")
      .forEach((details) => {
        if (details !== this.mainDetailsToggle) {
          details.removeAttribute("open");
          details
            .querySelector("summary")
            .setAttribute("aria-expanded", "false");
        }
      });
    // Close search modal if open
    const searchModal = document.querySelector("details-modal.header__search");
    if (searchModal && searchModal.isOpen()) {
      searchModal.close(false);
    }
    this.mainDetailsToggle.setAttribute("open", "");
    this.mainDetailsToggle
      .querySelector("summary")
      .setAttribute("aria-expanded", "true");
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (
      document.documentElement.style.getPropertyValue(
        "--header-bottom-position-desktop",
      ) !== ""
    )
      return;
    document.documentElement.style.setProperty(
      "--header-bottom-position-desktop",
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`,
    );
  }
}

customElements.define("header-menu", HeaderMenu);
